import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SpAttachmentLibraryComponent } from './sp-attachment-library.component';
import { SpAttachmentLibraryService } from './sp-attachment-library.service';
import { SpAttachmentConfig, SpAttachmentConfigService } from '../config';

// Third Party
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
    declarations: [SpAttachmentLibraryComponent],
    imports: [
        BrowserModule,
        FormsModule,
        SweetAlert2Module.forRoot({
            buttonsStyling: false,
            customClass: 'modal-content',
            confirmButtonClass: 'btn btn-primary',
            cancelButtonClass: 'btn'
        }),
        FontAwesomeModule,
    ],
    exports: [SpAttachmentLibraryComponent]
})
export class SpAttachmentLibraryModule {
    static forRoot(config: SpAttachmentConfig): ModuleWithProviders {
        return {
            ngModule: SpAttachmentLibraryModule,
            providers: [
                SpAttachmentLibraryService,
                {
                    provide: SpAttachmentConfigService,
                    useValue: config
                }
            ]
        };
    }
}
